export default __webpack_public_path__ + "static/media/faq-category-icon-2.8beb6ed5.svg";